import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=c0f89bd6&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f89bd6",
  null
  
)

export default component.exports